import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiNft
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiNftAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'baseURI_', internalType: 'string', type: 'string' },
      { name: 'owner_', internalType: 'address', type: 'address' },
      { name: 'registry_', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'identityOf',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'quantity', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'nextTokenId',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'registry',
    outputs: [
      {
        name: '',
        internalType: 'contract ShinkaiRegistryInterface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenIds', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes[]', type: 'bytes[]' },
    ],
    name: 'safeTransferFromBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenIds', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'safeTransferFromBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'baseURI_', internalType: 'string', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'registry_', internalType: 'address', type: 'address' }],
    name: 'setRegistry',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenIds', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'transferFromBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'toTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ConsecutiveTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  { type: 'error', inputs: [], name: 'ApprovalCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'ApprovalQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'MintERC2309QuantityExceedsLimit' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'MintZeroQuantity' },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'OwnableInvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
  },
  { type: 'error', inputs: [], name: 'OwnerQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'OwnershipNotInitializedForExtraData' },
  { type: 'error', inputs: [], name: 'TransferCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'URIQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'Unauthorized' },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiNftInterface
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiNftInterfaceAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'quantity', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'nextTokenId',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: '_approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'toTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ConsecutiveTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  { type: 'error', inputs: [], name: 'ApprovalCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'ApprovalQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'MintERC2309QuantityExceedsLimit' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'MintZeroQuantity' },
  { type: 'error', inputs: [], name: 'OwnerQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'OwnershipNotInitializedForExtraData' },
  { type: 'error', inputs: [], name: 'TransferCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'URIQueryForNonexistentToken' },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiRegistry
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiRegistryAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    inputs: [],
    name: 'UPGRADE_INTERFACE_VERSION',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'accrueDelegationRewards',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseRewardsRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseRewardsRateMaxMantissa',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimDelegationRewards',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimDelegationRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
    ],
    name: 'claimIdentity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
      {
        name: 'setDataParams',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams',
        type: 'tuple',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
      {
        name: 'delegations',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'claimIdentityAndSetData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams[]',
        type: 'tuple[]',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
    ],
    name: 'claimIdentityBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimRewards',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimStakingRewards',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimStakingRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseStake',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getAvailableTokensForDelegation',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getDelegatees',
    outputs: [{ name: '', internalType: 'string[]', type: 'string[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getIdentity',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getIdentityData',
    outputs: [
      {
        name: '',
        internalType: 'struct ShinkaiRegistryInterface.IdentityData',
        type: 'tuple',
        components: [
          { name: 'boundNft', internalType: 'uint256', type: 'uint256' },
          { name: 'stakedTokens', internalType: 'uint256', type: 'uint256' },
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
          { name: 'delegatedTokens', internalType: 'uint256', type: 'uint256' },
          { name: 'lastUpdated', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'string', type: 'string' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'identityDelegatees',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'string', type: 'string' }],
    name: 'identityDelegationAccrued',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'string', type: 'string' }],
    name: 'identityDelegationIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'string', type: 'string' },
      { name: '', internalType: 'string', type: 'string' },
    ],
    name: 'identityDelegations',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'string', type: 'string' },
      { name: '', internalType: 'string', type: 'string' },
    ],
    name: 'identityRecords',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
      { name: 'validReferrer', internalType: 'bool', type: 'bool' },
    ],
    name: 'identityStakeRequirement',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'string', type: 'string' }],
    name: 'identityStakingIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseStake',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner_', internalType: 'address', type: 'address' },
      { name: 'shinToken_', internalType: 'address', type: 'address' },
      { name: 'shinkaiNft_', internalType: 'address', type: 'address' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proxiableUUID',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'resetIdentityData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'rewardsState',
    outputs: [
      { name: 'index', internalType: 'uint224', type: 'uint224' },
      { name: 'block', internalType: 'uint32', type: 'uint32' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'rate', internalType: 'uint256', type: 'uint256' }],
    name: 'setBaseRewardsRate',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams',
        type: 'tuple',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
    ],
    name: 'setData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
      {
        name: 'setDataParams',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams[]',
        type: 'tuple[]',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
    ],
    name: 'setDataBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      {
        name: 'delegations',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'setDelegations',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'encryptionKey', internalType: 'string', type: 'string' },
      { name: 'signatureKey', internalType: 'string', type: 'string' },
    ],
    name: 'setKeys',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'namespace', internalType: 'string', type: 'string' },
    ],
    name: 'setNamespace',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'nodeAddress', internalType: 'string', type: 'string' },
    ],
    name: 'setNodeAddress',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'proxyNodes', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'setProxyNodes',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'shinToken',
    outputs: [
      {
        name: '',
        internalType: 'contract ShinkaiTokenInterface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'shinkaiNft',
    outputs: [
      {
        name: '',
        internalType: 'contract ShinkaiNftInterface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenIdToIdentity',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'unclaimIdentity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'unclaimIdentityBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'keys', internalType: 'string[]', type: 'string[]' },
      { name: 'values', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'updateRecords',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'name', internalType: 'string', type: 'string' }],
    name: 'validName',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'pure',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      { name: 'routing', internalType: 'bool', type: 'bool', indexed: false },
      {
        name: 'addressOrProxyNodes',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
    ],
    name: 'AddressOrProxyNodesUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BaseRewardsRateUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'newDelegatedTokens',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DelegatedTokensUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'rewards',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DelegationRewardsAccrual',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'rewards',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DelegationRewardsClaim',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'delegations',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
        indexed: false,
      },
    ],
    name: 'DelegationsUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'nftTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'identityRaw',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'IdentityClaim',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'nftTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IdentityUnclaim',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'version',
        internalType: 'uint64',
        type: 'uint64',
        indexed: false,
      },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'encryptionKey',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'signatureKey',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'KeysUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'keys',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
    ],
    name: 'RecordsRemoval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'keys',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
    ],
    name: 'RecordsUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'newStake',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'StakeUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'identity',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'rewards',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'StakingRewardsClaim',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  {
    type: 'error',
    inputs: [{ name: 'target', internalType: 'address', type: 'address' }],
    name: 'AddressEmptyCode',
  },
  {
    type: 'error',
    inputs: [
      { name: 'delegatedTokens', internalType: 'uint256', type: 'uint256' },
      { name: 'stakedTokens', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DelegatedTokensExceedingStakedTokens',
  },
  {
    type: 'error',
    inputs: [
      { name: 'implementation', internalType: 'address', type: 'address' },
    ],
    name: 'ERC1967InvalidImplementation',
  },
  { type: 'error', inputs: [], name: 'ERC1967NonPayable' },
  { type: 'error', inputs: [], name: 'FailedInnerCall' },
  {
    type: 'error',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'IdentityNotAvailable',
  },
  { type: 'error', inputs: [], name: 'InputArityMismatch' },
  { type: 'error', inputs: [], name: 'InsufficientStakeAmountForDelegation' },
  { type: 'error', inputs: [], name: 'InsufficientStakeAmountForIdentity' },
  {
    type: 'error',
    inputs: [{ name: 'rate', internalType: 'uint256', type: 'uint256' }],
    name: 'InvalidBaseRewardsRate',
  },
  {
    type: 'error',
    inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    name: 'InvalidDelegationAmount',
  },
  { type: 'error', inputs: [], name: 'InvalidInitialization' },
  {
    type: 'error',
    inputs: [{ name: 'name', internalType: 'string', type: 'string' }],
    name: 'InvalidName',
  },
  {
    type: 'error',
    inputs: [{ name: 'namespace', internalType: 'uint256', type: 'uint256' }],
    name: 'InvalidNamespace',
  },
  {
    type: 'error',
    inputs: [{ name: 'referrer', internalType: 'string', type: 'string' }],
    name: 'InvalidReferrer',
  },
  { type: 'error', inputs: [], name: 'NotInitializing' },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'OwnableInvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
  },
  { type: 'error', inputs: [], name: 'UUPSUnauthorizedCallContext' },
  {
    type: 'error',
    inputs: [{ name: 'slot', internalType: 'bytes32', type: 'bytes32' }],
    name: 'UUPSUnsupportedProxiableUUID',
  },
  { type: 'error', inputs: [], name: 'Unauthorized' },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiRegistryHelper
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiRegistryHelperAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'owner_', internalType: 'address', type: 'address' },
      { name: 'registry_', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getDelegations',
    outputs: [
      {
        name: '',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getIdentityNodeAddresses',
    outputs: [{ name: '', internalType: 'string[]', type: 'string[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'registry',
    outputs: [
      {
        name: '',
        internalType: 'contract ShinkaiRegistryInterface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'registry_', internalType: 'address', type: 'address' }],
    name: 'setRegistry',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'OwnableInvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
  },
  { type: 'error', inputs: [], name: 'Unauthorized' },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiRegistryInterface
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiRegistryInterfaceAbi = [
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'accrueDelegationRewards',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimDelegationRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimDelegationRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
    ],
    name: 'claimIdentity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
      {
        name: 'setDataParams',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams',
        type: 'tuple',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
      {
        name: 'delegations',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'claimIdentityAndSetData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.ClaimIdentityParams[]',
        type: 'tuple[]',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'namespace', internalType: 'uint256', type: 'uint256' },
          { name: 'stakeAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'referrer', internalType: 'string', type: 'string' },
        ],
      },
    ],
    name: 'claimIdentityBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'claimStakingRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'claimStakingRewardsBatched',
    outputs: [
      { name: 'tokensAccrued', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseStake',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getAvailableTokensForDelegation',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getDelegatees',
    outputs: [{ name: '', internalType: 'string[]', type: 'string[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getIdentity',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'getIdentityData',
    outputs: [
      {
        name: '',
        internalType: 'struct ShinkaiRegistryInterface.IdentityData',
        type: 'tuple',
        components: [
          { name: 'boundNft', internalType: 'uint256', type: 'uint256' },
          { name: 'stakedTokens', internalType: 'uint256', type: 'uint256' },
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
          { name: 'delegatedTokens', internalType: 'uint256', type: 'uint256' },
          { name: 'lastUpdated', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'string', type: 'string' },
      { name: 'delegatee', internalType: 'string', type: 'string' },
    ],
    name: 'identityDelegations',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'keys', internalType: 'string', type: 'string' },
    ],
    name: 'identityRecords',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'namespace', internalType: 'uint256', type: 'uint256' },
      { name: 'validReferrer', internalType: 'bool', type: 'bool' },
    ],
    name: 'identityStakeRequirement',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseStake',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'resetIdentityData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'rate', internalType: 'uint256', type: 'uint256' }],
    name: 'setBaseRewardsRate',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      {
        name: 'params',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams',
        type: 'tuple',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
    ],
    name: 'setData',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
      {
        name: 'setDataParams',
        internalType: 'struct ShinkaiRegistryInterface.SetDataParams[]',
        type: 'tuple[]',
        components: [
          { name: 'encryptionKey', internalType: 'string', type: 'string' },
          { name: 'signatureKey', internalType: 'string', type: 'string' },
          { name: 'routing', internalType: 'bool', type: 'bool' },
          {
            name: 'addressOrProxyNodes',
            internalType: 'string[]',
            type: 'string[]',
          },
        ],
      },
    ],
    name: 'setDataBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      {
        name: 'delegations',
        internalType: 'struct ShinkaiRegistryInterface.Delegation[]',
        type: 'tuple[]',
        components: [
          { name: 'delegatee', internalType: 'string', type: 'string' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'setDelegations',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'encryptionKey', internalType: 'string', type: 'string' },
      { name: 'signatureKey', internalType: 'string', type: 'string' },
    ],
    name: 'setKeys',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'nodeAddress', internalType: 'string', type: 'string' },
    ],
    name: 'setNodeAddress',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'proxyNodes', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'setProxyNodes',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenIdToIdentity',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'identity', internalType: 'string', type: 'string' }],
    name: 'unclaimIdentity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identities', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'unclaimIdentityBatched',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'identity', internalType: 'string', type: 'string' },
      { name: 'keys', internalType: 'string[]', type: 'string[]' },
      { name: 'values', internalType: 'string[]', type: 'string[]' },
    ],
    name: 'updateRecords',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiToken
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiTokenAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'initialSupply', internalType: 'uint256', type: 'uint256' },
      { name: 'owner_', internalType: 'address', type: 'address' },
      { name: 'registry_', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'registry',
    outputs: [
      {
        name: '',
        internalType: 'contract ShinkaiRegistryInterface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'registry_', internalType: 'address', type: 'address' }],
    name: 'setRegistry',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'error',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'allowance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientAllowance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidApprover',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSender',
  },
  {
    type: 'error',
    inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSpender',
  },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'OwnableInvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
  },
  { type: 'error', inputs: [], name: 'Unauthorized' },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ShinkaiTokenInterface
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const shinkaiTokenInterfaceAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__
 */
export const useReadShinkaiNft = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadShinkaiNftBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'balanceOf',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"baseURI"`
 */
export const useReadShinkaiNftBaseUri = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'baseURI',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"getApproved"`
 */
export const useReadShinkaiNftGetApproved = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiNftAbi, functionName: 'getApproved' },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"identityOf"`
 */
export const useReadShinkaiNftIdentityOf = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'identityOf',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadShinkaiNftIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftAbi,
    functionName: 'isApprovedForAll',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"name"`
 */
export const useReadShinkaiNftName = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'name',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"nextTokenId"`
 */
export const useReadShinkaiNftNextTokenId = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiNftAbi, functionName: 'nextTokenId' },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"owner"`
 */
export const useReadShinkaiNftOwner = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'owner',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadShinkaiNftOwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'ownerOf',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"registry"`
 */
export const useReadShinkaiNftRegistry = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'registry',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadShinkaiNftSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftAbi,
    functionName: 'supportsInterface',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadShinkaiNftSymbol = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'symbol',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadShinkaiNftTokenUri = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftAbi,
  functionName: 'tokenURI',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadShinkaiNftTotalSupply = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiNftAbi, functionName: 'totalSupply' },
);

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__
 */
export const useWriteShinkaiNft = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiNftAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteShinkaiNftApprove = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiNftAbi,
  functionName: 'approve',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"burn"`
 */
export const useWriteShinkaiNftBurn = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiNftAbi,
  functionName: 'burn',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"mint"`
 */
export const useWriteShinkaiNftMint = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiNftAbi,
  functionName: 'mint',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteShinkaiNftRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteShinkaiNftSafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'safeTransferFrom',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"safeTransferFromBatched"`
 */
export const useWriteShinkaiNftSafeTransferFromBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'safeTransferFromBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteShinkaiNftSetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'setApprovalForAll',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setBaseURI"`
 */
export const useWriteShinkaiNftSetBaseUri =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'setBaseURI',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useWriteShinkaiNftSetRegistry =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteShinkaiNftTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferFromBatched"`
 */
export const useWriteShinkaiNftTransferFromBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'transferFromBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteShinkaiNftTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__
 */
export const useSimulateShinkaiNft = /*#__PURE__*/ createUseSimulateContract({
  abi: shinkaiNftAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateShinkaiNftApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"burn"`
 */
export const useSimulateShinkaiNftBurn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'burn',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"mint"`
 */
export const useSimulateShinkaiNftMint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateShinkaiNftRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateShinkaiNftSafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'safeTransferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"safeTransferFromBatched"`
 */
export const useSimulateShinkaiNftSafeTransferFromBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'safeTransferFromBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateShinkaiNftSetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'setApprovalForAll',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setBaseURI"`
 */
export const useSimulateShinkaiNftSetBaseUri =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'setBaseURI',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useSimulateShinkaiNftSetRegistry =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateShinkaiNftTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferFromBatched"`
 */
export const useSimulateShinkaiNftTransferFromBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'transferFromBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateShinkaiNftTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__
 */
export const useWatchShinkaiNftEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiNftAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchShinkaiNftApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftAbi,
    eventName: 'Approval',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchShinkaiNftApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftAbi,
    eventName: 'ApprovalForAll',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__ and `eventName` set to `"ConsecutiveTransfer"`
 */
export const useWatchShinkaiNftConsecutiveTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftAbi,
    eventName: 'ConsecutiveTransfer',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchShinkaiNftOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftAbi,
    eventName: 'OwnershipTransferred',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchShinkaiNftTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftAbi,
    eventName: 'Transfer',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__
 */
export const useReadShinkaiNftInterface = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiNftInterfaceAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadShinkaiNftInterfaceBalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'balanceOf',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"getApproved"`
 */
export const useReadShinkaiNftInterfaceGetApproved =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'getApproved',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadShinkaiNftInterfaceIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'isApprovedForAll',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"name"`
 */
export const useReadShinkaiNftInterfaceName =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'name',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"nextTokenId"`
 */
export const useReadShinkaiNftInterfaceNextTokenId =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'nextTokenId',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadShinkaiNftInterfaceOwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'ownerOf',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadShinkaiNftInterfaceSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'supportsInterface',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadShinkaiNftInterfaceSymbol =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'symbol',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadShinkaiNftInterfaceTokenUri =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'tokenURI',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadShinkaiNftInterfaceTotalSupply =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'totalSupply',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__
 */
export const useWriteShinkaiNftInterface = /*#__PURE__*/ createUseWriteContract(
  { abi: shinkaiNftInterfaceAbi },
);

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteShinkaiNftInterfaceApprove =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"burn"`
 */
export const useWriteShinkaiNftInterfaceBurn =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'burn',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"mint"`
 */
export const useWriteShinkaiNftInterfaceMint =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteShinkaiNftInterfaceSafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'safeTransferFrom',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteShinkaiNftInterfaceSetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'setApprovalForAll',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteShinkaiNftInterfaceTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__
 */
export const useSimulateShinkaiNftInterface =
  /*#__PURE__*/ createUseSimulateContract({ abi: shinkaiNftInterfaceAbi });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateShinkaiNftInterfaceApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"burn"`
 */
export const useSimulateShinkaiNftInterfaceBurn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'burn',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"mint"`
 */
export const useSimulateShinkaiNftInterfaceMint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateShinkaiNftInterfaceSafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'safeTransferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateShinkaiNftInterfaceSetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'setApprovalForAll',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateShinkaiNftInterfaceTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiNftInterfaceAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__
 */
export const useWatchShinkaiNftInterfaceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiNftInterfaceAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchShinkaiNftInterfaceApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftInterfaceAbi,
    eventName: 'Approval',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchShinkaiNftInterfaceApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftInterfaceAbi,
    eventName: 'ApprovalForAll',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `eventName` set to `"ConsecutiveTransfer"`
 */
export const useWatchShinkaiNftInterfaceConsecutiveTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftInterfaceAbi,
    eventName: 'ConsecutiveTransfer',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiNftInterfaceAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchShinkaiNftInterfaceTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiNftInterfaceAbi,
    eventName: 'Transfer',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__
 */
export const useReadShinkaiRegistry = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiRegistryAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"UPGRADE_INTERFACE_VERSION"`
 */
export const useReadShinkaiRegistryUpgradeInterfaceVersion =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'UPGRADE_INTERFACE_VERSION',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"baseRewardsRate"`
 */
export const useReadShinkaiRegistryBaseRewardsRate =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'baseRewardsRate',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"baseRewardsRateMaxMantissa"`
 */
export const useReadShinkaiRegistryBaseRewardsRateMaxMantissa =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'baseRewardsRateMaxMantissa',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"getAvailableTokensForDelegation"`
 */
export const useReadShinkaiRegistryGetAvailableTokensForDelegation =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'getAvailableTokensForDelegation',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"getDelegatees"`
 */
export const useReadShinkaiRegistryGetDelegatees =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'getDelegatees',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"getIdentity"`
 */
export const useReadShinkaiRegistryGetIdentity =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'getIdentity',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"getIdentityData"`
 */
export const useReadShinkaiRegistryGetIdentityData =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'getIdentityData',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityDelegatees"`
 */
export const useReadShinkaiRegistryIdentityDelegatees =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityDelegatees',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityDelegationAccrued"`
 */
export const useReadShinkaiRegistryIdentityDelegationAccrued =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityDelegationAccrued',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityDelegationIndex"`
 */
export const useReadShinkaiRegistryIdentityDelegationIndex =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityDelegationIndex',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityDelegations"`
 */
export const useReadShinkaiRegistryIdentityDelegations =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityDelegations',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityRecords"`
 */
export const useReadShinkaiRegistryIdentityRecords =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityRecords',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityStakeRequirement"`
 */
export const useReadShinkaiRegistryIdentityStakeRequirement =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityStakeRequirement',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"identityStakingIndex"`
 */
export const useReadShinkaiRegistryIdentityStakingIndex =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'identityStakingIndex',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"owner"`
 */
export const useReadShinkaiRegistryOwner = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiRegistryAbi,
  functionName: 'owner',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadShinkaiRegistryOwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'ownerOf',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"proxiableUUID"`
 */
export const useReadShinkaiRegistryProxiableUuid =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'proxiableUUID',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"rewardsState"`
 */
export const useReadShinkaiRegistryRewardsState =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'rewardsState',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"shinToken"`
 */
export const useReadShinkaiRegistryShinToken =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'shinToken',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"shinkaiNft"`
 */
export const useReadShinkaiRegistryShinkaiNft =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'shinkaiNft',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"tokenIdToIdentity"`
 */
export const useReadShinkaiRegistryTokenIdToIdentity =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'tokenIdToIdentity',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"validName"`
 */
export const useReadShinkaiRegistryValidName =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryAbi,
    functionName: 'validName',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__
 */
export const useWriteShinkaiRegistry = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiRegistryAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"accrueDelegationRewards"`
 */
export const useWriteShinkaiRegistryAccrueDelegationRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'accrueDelegationRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimDelegationRewards"`
 */
export const useWriteShinkaiRegistryClaimDelegationRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimDelegationRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimDelegationRewardsBatched"`
 */
export const useWriteShinkaiRegistryClaimDelegationRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimDelegationRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentity"`
 */
export const useWriteShinkaiRegistryClaimIdentity =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentity',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentityAndSetData"`
 */
export const useWriteShinkaiRegistryClaimIdentityAndSetData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentityAndSetData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentityBatched"`
 */
export const useWriteShinkaiRegistryClaimIdentityBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentityBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimRewards"`
 */
export const useWriteShinkaiRegistryClaimRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimRewardsBatched"`
 */
export const useWriteShinkaiRegistryClaimRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimStakingRewards"`
 */
export const useWriteShinkaiRegistryClaimStakingRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimStakingRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimStakingRewardsBatched"`
 */
export const useWriteShinkaiRegistryClaimStakingRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimStakingRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"decreaseStake"`
 */
export const useWriteShinkaiRegistryDecreaseStake =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'decreaseStake',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"increaseStake"`
 */
export const useWriteShinkaiRegistryIncreaseStake =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'increaseStake',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteShinkaiRegistryInitialize =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'initialize',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteShinkaiRegistryRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"resetIdentityData"`
 */
export const useWriteShinkaiRegistryResetIdentityData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'resetIdentityData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setBaseRewardsRate"`
 */
export const useWriteShinkaiRegistrySetBaseRewardsRate =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setBaseRewardsRate',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setData"`
 */
export const useWriteShinkaiRegistrySetData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setDataBatched"`
 */
export const useWriteShinkaiRegistrySetDataBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setDataBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setDelegations"`
 */
export const useWriteShinkaiRegistrySetDelegations =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setDelegations',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setKeys"`
 */
export const useWriteShinkaiRegistrySetKeys =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setKeys',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setNamespace"`
 */
export const useWriteShinkaiRegistrySetNamespace =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setNamespace',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setNodeAddress"`
 */
export const useWriteShinkaiRegistrySetNodeAddress =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setNodeAddress',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setProxyNodes"`
 */
export const useWriteShinkaiRegistrySetProxyNodes =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setProxyNodes',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteShinkaiRegistryTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"unclaimIdentity"`
 */
export const useWriteShinkaiRegistryUnclaimIdentity =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'unclaimIdentity',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"unclaimIdentityBatched"`
 */
export const useWriteShinkaiRegistryUnclaimIdentityBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'unclaimIdentityBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"updateRecords"`
 */
export const useWriteShinkaiRegistryUpdateRecords =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'updateRecords',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"upgradeToAndCall"`
 */
export const useWriteShinkaiRegistryUpgradeToAndCall =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryAbi,
    functionName: 'upgradeToAndCall',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__
 */
export const useSimulateShinkaiRegistry =
  /*#__PURE__*/ createUseSimulateContract({ abi: shinkaiRegistryAbi });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"accrueDelegationRewards"`
 */
export const useSimulateShinkaiRegistryAccrueDelegationRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'accrueDelegationRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimDelegationRewards"`
 */
export const useSimulateShinkaiRegistryClaimDelegationRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimDelegationRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimDelegationRewardsBatched"`
 */
export const useSimulateShinkaiRegistryClaimDelegationRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimDelegationRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentity"`
 */
export const useSimulateShinkaiRegistryClaimIdentity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentity',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentityAndSetData"`
 */
export const useSimulateShinkaiRegistryClaimIdentityAndSetData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentityAndSetData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimIdentityBatched"`
 */
export const useSimulateShinkaiRegistryClaimIdentityBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimIdentityBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimRewards"`
 */
export const useSimulateShinkaiRegistryClaimRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimRewardsBatched"`
 */
export const useSimulateShinkaiRegistryClaimRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimStakingRewards"`
 */
export const useSimulateShinkaiRegistryClaimStakingRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimStakingRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"claimStakingRewardsBatched"`
 */
export const useSimulateShinkaiRegistryClaimStakingRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'claimStakingRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"decreaseStake"`
 */
export const useSimulateShinkaiRegistryDecreaseStake =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'decreaseStake',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"increaseStake"`
 */
export const useSimulateShinkaiRegistryIncreaseStake =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'increaseStake',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateShinkaiRegistryInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'initialize',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateShinkaiRegistryRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"resetIdentityData"`
 */
export const useSimulateShinkaiRegistryResetIdentityData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'resetIdentityData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setBaseRewardsRate"`
 */
export const useSimulateShinkaiRegistrySetBaseRewardsRate =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setBaseRewardsRate',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setData"`
 */
export const useSimulateShinkaiRegistrySetData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setDataBatched"`
 */
export const useSimulateShinkaiRegistrySetDataBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setDataBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setDelegations"`
 */
export const useSimulateShinkaiRegistrySetDelegations =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setDelegations',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setKeys"`
 */
export const useSimulateShinkaiRegistrySetKeys =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setKeys',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setNamespace"`
 */
export const useSimulateShinkaiRegistrySetNamespace =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setNamespace',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setNodeAddress"`
 */
export const useSimulateShinkaiRegistrySetNodeAddress =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setNodeAddress',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"setProxyNodes"`
 */
export const useSimulateShinkaiRegistrySetProxyNodes =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'setProxyNodes',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateShinkaiRegistryTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"unclaimIdentity"`
 */
export const useSimulateShinkaiRegistryUnclaimIdentity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'unclaimIdentity',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"unclaimIdentityBatched"`
 */
export const useSimulateShinkaiRegistryUnclaimIdentityBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'unclaimIdentityBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"updateRecords"`
 */
export const useSimulateShinkaiRegistryUpdateRecords =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'updateRecords',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `functionName` set to `"upgradeToAndCall"`
 */
export const useSimulateShinkaiRegistryUpgradeToAndCall =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryAbi,
    functionName: 'upgradeToAndCall',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__
 */
export const useWatchShinkaiRegistryEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiRegistryAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"AddressOrProxyNodesUpdate"`
 */
export const useWatchShinkaiRegistryAddressOrProxyNodesUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'AddressOrProxyNodesUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"BaseRewardsRateUpdate"`
 */
export const useWatchShinkaiRegistryBaseRewardsRateUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'BaseRewardsRateUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"DelegatedTokensUpdate"`
 */
export const useWatchShinkaiRegistryDelegatedTokensUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'DelegatedTokensUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"DelegationRewardsAccrual"`
 */
export const useWatchShinkaiRegistryDelegationRewardsAccrualEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'DelegationRewardsAccrual',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"DelegationRewardsClaim"`
 */
export const useWatchShinkaiRegistryDelegationRewardsClaimEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'DelegationRewardsClaim',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"DelegationsUpdate"`
 */
export const useWatchShinkaiRegistryDelegationsUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'DelegationsUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"IdentityClaim"`
 */
export const useWatchShinkaiRegistryIdentityClaimEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'IdentityClaim',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"IdentityUnclaim"`
 */
export const useWatchShinkaiRegistryIdentityUnclaimEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'IdentityUnclaim',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchShinkaiRegistryInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'Initialized',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"KeysUpdate"`
 */
export const useWatchShinkaiRegistryKeysUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'KeysUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchShinkaiRegistryOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'OwnershipTransferred',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"RecordsRemoval"`
 */
export const useWatchShinkaiRegistryRecordsRemovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'RecordsRemoval',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"RecordsUpdate"`
 */
export const useWatchShinkaiRegistryRecordsUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'RecordsUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"StakeUpdate"`
 */
export const useWatchShinkaiRegistryStakeUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'StakeUpdate',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"StakingRewardsClaim"`
 */
export const useWatchShinkaiRegistryStakingRewardsClaimEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'StakingRewardsClaim',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryAbi}__ and `eventName` set to `"Upgraded"`
 */
export const useWatchShinkaiRegistryUpgradedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryAbi,
    eventName: 'Upgraded',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__
 */
export const useReadShinkaiRegistryHelper = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiRegistryHelperAbi },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"getDelegations"`
 */
export const useReadShinkaiRegistryHelperGetDelegations =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'getDelegations',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"getIdentityNodeAddresses"`
 */
export const useReadShinkaiRegistryHelperGetIdentityNodeAddresses =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'getIdentityNodeAddresses',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"owner"`
 */
export const useReadShinkaiRegistryHelperOwner =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'owner',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"registry"`
 */
export const useReadShinkaiRegistryHelperRegistry =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'registry',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__
 */
export const useWriteShinkaiRegistryHelper =
  /*#__PURE__*/ createUseWriteContract({ abi: shinkaiRegistryHelperAbi });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteShinkaiRegistryHelperRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useWriteShinkaiRegistryHelperSetRegistry =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteShinkaiRegistryHelperTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__
 */
export const useSimulateShinkaiRegistryHelper =
  /*#__PURE__*/ createUseSimulateContract({ abi: shinkaiRegistryHelperAbi });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateShinkaiRegistryHelperRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useSimulateShinkaiRegistryHelperSetRegistry =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateShinkaiRegistryHelperTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryHelperAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__
 */
export const useWatchShinkaiRegistryHelperEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiRegistryHelperAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiRegistryHelperAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchShinkaiRegistryHelperOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiRegistryHelperAbi,
    eventName: 'OwnershipTransferred',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__
 */
export const useReadShinkaiRegistryInterface =
  /*#__PURE__*/ createUseReadContract({ abi: shinkaiRegistryInterfaceAbi });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"getAvailableTokensForDelegation"`
 */
export const useReadShinkaiRegistryInterfaceGetAvailableTokensForDelegation =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'getAvailableTokensForDelegation',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"getDelegatees"`
 */
export const useReadShinkaiRegistryInterfaceGetDelegatees =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'getDelegatees',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"getIdentity"`
 */
export const useReadShinkaiRegistryInterfaceGetIdentity =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'getIdentity',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"getIdentityData"`
 */
export const useReadShinkaiRegistryInterfaceGetIdentityData =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'getIdentityData',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"identityDelegations"`
 */
export const useReadShinkaiRegistryInterfaceIdentityDelegations =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'identityDelegations',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"identityRecords"`
 */
export const useReadShinkaiRegistryInterfaceIdentityRecords =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'identityRecords',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"identityStakeRequirement"`
 */
export const useReadShinkaiRegistryInterfaceIdentityStakeRequirement =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'identityStakeRequirement',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadShinkaiRegistryInterfaceOwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'ownerOf',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"tokenIdToIdentity"`
 */
export const useReadShinkaiRegistryInterfaceTokenIdToIdentity =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'tokenIdToIdentity',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__
 */
export const useWriteShinkaiRegistryInterface =
  /*#__PURE__*/ createUseWriteContract({ abi: shinkaiRegistryInterfaceAbi });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"accrueDelegationRewards"`
 */
export const useWriteShinkaiRegistryInterfaceAccrueDelegationRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'accrueDelegationRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimDelegationRewards"`
 */
export const useWriteShinkaiRegistryInterfaceClaimDelegationRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimDelegationRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimDelegationRewardsBatched"`
 */
export const useWriteShinkaiRegistryInterfaceClaimDelegationRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimDelegationRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentity"`
 */
export const useWriteShinkaiRegistryInterfaceClaimIdentity =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentity',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentityAndSetData"`
 */
export const useWriteShinkaiRegistryInterfaceClaimIdentityAndSetData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentityAndSetData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentityBatched"`
 */
export const useWriteShinkaiRegistryInterfaceClaimIdentityBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentityBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimRewards"`
 */
export const useWriteShinkaiRegistryInterfaceClaimRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimRewardsBatched"`
 */
export const useWriteShinkaiRegistryInterfaceClaimRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimStakingRewards"`
 */
export const useWriteShinkaiRegistryInterfaceClaimStakingRewards =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimStakingRewards',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimStakingRewardsBatched"`
 */
export const useWriteShinkaiRegistryInterfaceClaimStakingRewardsBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimStakingRewardsBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"decreaseStake"`
 */
export const useWriteShinkaiRegistryInterfaceDecreaseStake =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'decreaseStake',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"increaseStake"`
 */
export const useWriteShinkaiRegistryInterfaceIncreaseStake =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'increaseStake',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"resetIdentityData"`
 */
export const useWriteShinkaiRegistryInterfaceResetIdentityData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'resetIdentityData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setBaseRewardsRate"`
 */
export const useWriteShinkaiRegistryInterfaceSetBaseRewardsRate =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setBaseRewardsRate',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setData"`
 */
export const useWriteShinkaiRegistryInterfaceSetData =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setData',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setDataBatched"`
 */
export const useWriteShinkaiRegistryInterfaceSetDataBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setDataBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setDelegations"`
 */
export const useWriteShinkaiRegistryInterfaceSetDelegations =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setDelegations',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setKeys"`
 */
export const useWriteShinkaiRegistryInterfaceSetKeys =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setKeys',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setNodeAddress"`
 */
export const useWriteShinkaiRegistryInterfaceSetNodeAddress =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setNodeAddress',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setProxyNodes"`
 */
export const useWriteShinkaiRegistryInterfaceSetProxyNodes =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setProxyNodes',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"unclaimIdentity"`
 */
export const useWriteShinkaiRegistryInterfaceUnclaimIdentity =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'unclaimIdentity',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"unclaimIdentityBatched"`
 */
export const useWriteShinkaiRegistryInterfaceUnclaimIdentityBatched =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'unclaimIdentityBatched',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"updateRecords"`
 */
export const useWriteShinkaiRegistryInterfaceUpdateRecords =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'updateRecords',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__
 */
export const useSimulateShinkaiRegistryInterface =
  /*#__PURE__*/ createUseSimulateContract({ abi: shinkaiRegistryInterfaceAbi });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"accrueDelegationRewards"`
 */
export const useSimulateShinkaiRegistryInterfaceAccrueDelegationRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'accrueDelegationRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimDelegationRewards"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimDelegationRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimDelegationRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimDelegationRewardsBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimDelegationRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimDelegationRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentity"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimIdentity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentity',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentityAndSetData"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimIdentityAndSetData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentityAndSetData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimIdentityBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimIdentityBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimIdentityBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimRewards"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimRewardsBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimStakingRewards"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimStakingRewards =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimStakingRewards',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"claimStakingRewardsBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceClaimStakingRewardsBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'claimStakingRewardsBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"decreaseStake"`
 */
export const useSimulateShinkaiRegistryInterfaceDecreaseStake =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'decreaseStake',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"increaseStake"`
 */
export const useSimulateShinkaiRegistryInterfaceIncreaseStake =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'increaseStake',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"resetIdentityData"`
 */
export const useSimulateShinkaiRegistryInterfaceResetIdentityData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'resetIdentityData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setBaseRewardsRate"`
 */
export const useSimulateShinkaiRegistryInterfaceSetBaseRewardsRate =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setBaseRewardsRate',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setData"`
 */
export const useSimulateShinkaiRegistryInterfaceSetData =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setData',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setDataBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceSetDataBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setDataBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setDelegations"`
 */
export const useSimulateShinkaiRegistryInterfaceSetDelegations =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setDelegations',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setKeys"`
 */
export const useSimulateShinkaiRegistryInterfaceSetKeys =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setKeys',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setNodeAddress"`
 */
export const useSimulateShinkaiRegistryInterfaceSetNodeAddress =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setNodeAddress',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"setProxyNodes"`
 */
export const useSimulateShinkaiRegistryInterfaceSetProxyNodes =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'setProxyNodes',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"unclaimIdentity"`
 */
export const useSimulateShinkaiRegistryInterfaceUnclaimIdentity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'unclaimIdentity',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"unclaimIdentityBatched"`
 */
export const useSimulateShinkaiRegistryInterfaceUnclaimIdentityBatched =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'unclaimIdentityBatched',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiRegistryInterfaceAbi}__ and `functionName` set to `"updateRecords"`
 */
export const useSimulateShinkaiRegistryInterfaceUpdateRecords =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiRegistryInterfaceAbi,
    functionName: 'updateRecords',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__
 */
export const useReadShinkaiToken = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"allowance"`
 */
export const useReadShinkaiTokenAllowance = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiTokenAbi, functionName: 'allowance' },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadShinkaiTokenBalanceOf = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiTokenAbi, functionName: 'balanceOf' },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"decimals"`
 */
export const useReadShinkaiTokenDecimals = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
  functionName: 'decimals',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"name"`
 */
export const useReadShinkaiTokenName = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
  functionName: 'name',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"owner"`
 */
export const useReadShinkaiTokenOwner = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
  functionName: 'owner',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"registry"`
 */
export const useReadShinkaiTokenRegistry = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
  functionName: 'registry',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadShinkaiTokenSymbol = /*#__PURE__*/ createUseReadContract({
  abi: shinkaiTokenAbi,
  functionName: 'symbol',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadShinkaiTokenTotalSupply =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiTokenAbi,
    functionName: 'totalSupply',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__
 */
export const useWriteShinkaiToken = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiTokenAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteShinkaiTokenApprove = /*#__PURE__*/ createUseWriteContract(
  { abi: shinkaiTokenAbi, functionName: 'approve' },
);

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"mint"`
 */
export const useWriteShinkaiTokenMint = /*#__PURE__*/ createUseWriteContract({
  abi: shinkaiTokenAbi,
  functionName: 'mint',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteShinkaiTokenRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useWriteShinkaiTokenSetRegistry =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transfer"`
 */
export const useWriteShinkaiTokenTransfer =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenAbi,
    functionName: 'transfer',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteShinkaiTokenTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteShinkaiTokenTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__
 */
export const useSimulateShinkaiToken = /*#__PURE__*/ createUseSimulateContract({
  abi: shinkaiTokenAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateShinkaiTokenApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"mint"`
 */
export const useSimulateShinkaiTokenMint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateShinkaiTokenRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'renounceOwnership',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"setRegistry"`
 */
export const useSimulateShinkaiTokenSetRegistry =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'setRegistry',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateShinkaiTokenTransfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'transfer',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateShinkaiTokenTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateShinkaiTokenTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenAbi,
    functionName: 'transferOwnership',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenAbi}__
 */
export const useWatchShinkaiTokenEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiTokenAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchShinkaiTokenApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiTokenAbi,
    eventName: 'Approval',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchShinkaiTokenOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiTokenAbi,
    eventName: 'OwnershipTransferred',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchShinkaiTokenTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiTokenAbi,
    eventName: 'Transfer',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__
 */
export const useReadShinkaiTokenInterface = /*#__PURE__*/ createUseReadContract(
  { abi: shinkaiTokenInterfaceAbi },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"allowance"`
 */
export const useReadShinkaiTokenInterfaceAllowance =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'allowance',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadShinkaiTokenInterfaceBalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'balanceOf',
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadShinkaiTokenInterfaceTotalSupply =
  /*#__PURE__*/ createUseReadContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'totalSupply',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__
 */
export const useWriteShinkaiTokenInterface =
  /*#__PURE__*/ createUseWriteContract({ abi: shinkaiTokenInterfaceAbi });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteShinkaiTokenInterfaceApprove =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"mint"`
 */
export const useWriteShinkaiTokenInterfaceMint =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"transfer"`
 */
export const useWriteShinkaiTokenInterfaceTransfer =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'transfer',
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteShinkaiTokenInterfaceTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__
 */
export const useSimulateShinkaiTokenInterface =
  /*#__PURE__*/ createUseSimulateContract({ abi: shinkaiTokenInterfaceAbi });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateShinkaiTokenInterfaceApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'approve',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"mint"`
 */
export const useSimulateShinkaiTokenInterfaceMint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'mint',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateShinkaiTokenInterfaceTransfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'transfer',
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateShinkaiTokenInterfaceTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: shinkaiTokenInterfaceAbi,
    functionName: 'transferFrom',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__
 */
export const useWatchShinkaiTokenInterfaceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: shinkaiTokenInterfaceAbi });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchShinkaiTokenInterfaceApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiTokenInterfaceAbi,
    eventName: 'Approval',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link shinkaiTokenInterfaceAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchShinkaiTokenInterfaceTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: shinkaiTokenInterfaceAbi,
    eventName: 'Transfer',
  });
